import { downloadAuthorizedFile, request } from './core.api';

export interface DocumentDto {
  id: string;
  propertyId?: string;
  propertyAddress?: string;
  tenantId?: string;
  tenantName?: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  documentType: string;
  expiryDate?: string;
  tags?: string;
  createdAt: string;
}

export interface CreateDocumentRequest {
  propertyId?: string;
  tenantId?: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  documentType: string;
  expiryDate?: string;
  tags?: string;
}

export interface DocumentUploadUrlDto {
  documentId: string;
  uploadUrl: string;
}

export interface DocumentShareLinkDto {
  url: string;
  expiresAt: string;
}

export const documentsApi = {
  getAll: () => request<DocumentDto[]>('/documents'),
  getByProperty: (propertyId: string) => request<DocumentDto[]>(`/properties/${propertyId}/documents`),
  getByTenant: (tenantId: string) => request<DocumentDto[]>(`/tenants/${tenantId}/documents`),
  create: (data: CreateDocumentRequest) => request<DocumentUploadUrlDto>('/documents', { method: 'POST', body: JSON.stringify(data) }),
  download: (id: string, fileName?: string) => downloadAuthorizedFile(`/documents/${id}/download`, fileName),
  createShareLink: (id: string) => request<DocumentShareLinkDto>(`/documents/${id}/share-link`, { method: 'POST' }),
  delete: (id: string) => request<void>(`/documents/${id}`, { method: 'DELETE' }),
};
